import { render, staticRenderFns } from "./noticeWeapp.vue?vue&type=template&id=2acb8cef&scoped=true"
import script from "./noticeWeapp.vue?vue&type=script&lang=js"
export * from "./noticeWeapp.vue?vue&type=script&lang=js"
import style0 from "./noticeWeapp.vue?vue&type=style&index=0&id=2acb8cef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acb8cef",
  null
  
)

component.options.__file = "noticeWeapp.vue"
export default component.exports